import React from "react"
import FieldHelp from "../../help-and-hint/field-help/field-help";

export enum PopoverMenuOptionSelectionType {
    DEFAULT = 'default',
    LEFT    = 'left',
    BOLD    = 'bold',
}

type Props = {

    id?             : string,
    className?      : string,
    highlightClass  : string

    option          : Option,
    iconComponent?  : any,

    selected?       : boolean,
    isSelected?     : boolean,        // do we need it ???
    selectionType?  : PopoverMenuOptionSelectionType
    checkPro?       : boolean,
    disabled?       : boolean,
    isHighlighted?  : boolean,

    onMouseEnter?   : callbackOption,
    onMouseLeave?   : callbackOption,
    onClick?        : callback,
    onClickDisabled?: callback,
    onClickUpgrade? : callback,

    children?       : any,

    hidePopover?    : func              // if passed automatically close popover

}

// ! onClick param is OPTION (!) not id
// that is why PopoverMenuItem is depricated

export default class PopoverMenuOption extends React.Component<Props> {

    static defaultProps = {
        highlightClass: ''
    }

    _isDisabled = () => {
        const optionDisabled = typeof this.props.option.disabled === 'boolean' ? this.props.option.disabled : false
        return this.props.disabled || optionDisabled
    }

    onClick = (e:React.SyntheticEvent) => {

        e.stopPropagation()

        if (this.props.option?.isSelected) return;

        if (this._isDisabled()) {
            this.props.onClickDisabled && this.props.onClickDisabled()
            return
        }

        // close popover
        this.props.hidePopover && this.props.hidePopover()

        const proLicenseOnly = !!this.props.checkPro && !gd.company.license.isPro
        if (proLicenseOnly) {
            this.props.onClickUpgrade && this.props.onClickUpgrade()
            return
        }

        // recommended
        if (this.props.option.onClick) {
            this.props.option.onClick()
            return
        }

        this.props.onClick && this.props.onClick(this.props.option)
    }

    onMouseEnter = (e:React.SyntheticEvent) => {
        this.props.onMouseEnter && this.props.onMouseEnter(this.props.option)
    }

    onMouseLeave = (e:React.SyntheticEvent) => {
        this.props.onMouseLeave && this.props.onMouseLeave(this.props.option)
    }

    render() {
        const proLicenseOnly = !!this.props.checkPro && !gd.company.license.isPro

        const isSelected : boolean = !!this.props.selected || !!this.props.isSelected || !!this.props.option?.isSelected
        const selectionType = _.get(this.props, 'selectionType', PopoverMenuOptionSelectionType.DEFAULT)

        const classes = Classes('option', this.props.className, {
            'with-icon'                 : !_.isNil(this.props.option.icon),
            'disabled'                  : this._isDisabled(),
            'selected'                  : isSelected && selectionType === PopoverMenuOptionSelectionType.DEFAULT,
            'selected-left'             : isSelected && selectionType === PopoverMenuOptionSelectionType.LEFT,
            'selected-bold'             : isSelected && selectionType === PopoverMenuOptionSelectionType.BOLD,
            'highlighted'               : this.props.isHighlighted,
            [this.props.highlightClass] : this.props.isHighlighted
        })

        return (
            <div id={this.props.id} className={classes} onClick={this.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {!_.isNil(this.props.option.icon) &&
                    <div className={Classes("ico", this.props.option.icon)}/>
                }

                {this.props.iconComponent || this.props.option.iconComponent}
                <div className="label">{this.props.option.label}</div>

                {proLicenseOnly && <div className="ui5-ico-pro"/>}

                {!!this.props.option.hint &&
                    <div className="flex-row-right-center flex-1">
                        <FieldHelp className="option-hint m-l-8" message={this.props.option.hint}/>
                    </div>
                }

                {this.props.children}
            </div>
        )
    }
}
